<template>
    <div class="station-widget-form">
        <div class="container">
            <div class="row center-lg">
            <div class="col-xs">
                <div class="form-wrapper">
                    <div class="tabs">
                        <div class="tab-item" :class="{'active': selectedTab === 0}" @click="selectTab(0)">
                            <i class="fa fa-map-marker"></i>
                            <span>Lokal verkaufen</span>
                        </div>
                        <div class="tab-item" :class="{'active': selectedTab === 1}" @click="selectTab(1)">
                            <i class="fa fa-couch"></i>
                            <span>Online verkaufen</span>
                        </div>
                    </div>
                    <div class="configurator-wrapper">
                        <Preselector />
                        <button type="button" class="go-to-wizard" @click="handleRedirect" name="Submit">
                            <i v-if="selectedTab===0" class="fa fa-map-marker"></i>
                            <i v-if="selectedTab===1" class="fa fa-couch"></i>
                            <span v-if="selectedTab===0">Lokal verkaufen</span>
                            <span v-if="selectedTab===1">Online verkaufen</span>
                            <i class="fas fa-arrow-right"></i>
                        </button>
                    </div>
                    <span class="note">
                        TÜV Rheinland verifizierte Preisbewertung erhalten 
                    </span>
                </div>
                <div class="policy-wrapper visible-online">
                    <ul v-if="selectedTab===0" class="unstyled-list">
                        <li>
                            <div class="icon">
                                <img src="../assets/icons/free-of-charge.svg" alt="100 % kostenlos">
                            </div>
                            <div class="policy-item-info">
                                <span class="title">100 % kostenlos</span>
                                <p>Keine versteckte Kosten & sofort Preisbewertung deines Autos in 1 Minute.</p>
                            </div>
                        </li>
                        <li>
                            <div class="icon">
                            <img src="../assets/icons/no-inquiries.svg" alt="Wunschtermin buchen & Angebot erhalten">
                            </div>
                            <div class="policy-item-info">
                                <span class="title">Wunschtermin buchen & Angebot erhalten</span>
                                <p>Vor-Ort-Termin bei PKW.de geprüften Partnerhändlern buchen und unverbindliches Angebot erhalten.</p>
                            </div>
                        </li>
                        <li>
                            <div class="icon">
                                <img src="../assets/icons/instant-money.svg" alt="Sofort Geld in bar per Blitzüberweisung">
                            </div>
                            <div class="policy-item-info">
                                <span class="title">Sofort Geld in bar per Blitzüberweisung</span>
                                <p>Verkaufen, wenn dir das Angebot zusagt.  Die Abmeldung übernimmt der Partnerhändler.</p>
                            </div>
                        </li>
                    </ul>

                    <ul v-if="selectedTab===1" class="unstyled-list">
                        <li>
                            <div class="icon">
                                <img src="../assets/icons/free-of-charge.svg" alt="100 % kostenlos">
                            </div>
                            <div class="policy-item-info">
                                <span class="title">100 % kostenlos</span>
                                <p>Keine versteckte Kosten & sofort Preisbewertung deines Autos in 1 Minute.</p>
                            </div>
                        </li>
                        <li>
                            <div class="icon">
                            <img src="../assets/icons/no-inquiries.svg" alt="Keine lästigen Anfragen & Nachverhandeln">
                            </div>
                            <div class="policy-item-info">
                                <span class="title">Keine lästigen Anfragen & Nachverhandeln</span>
                                <p>Startpreis festlegen und Höchstgebote von PKW.de geprüften Partnerhändlern erhalten.</p>
                            </div>
                        </li>
                        <li>
                            <div class="icon">
                                <img src="../assets/icons/instant-money.svg" alt="Sofort Geld - Abholung & Abmeldung inklusive">
                            </div>
                            <div class="policy-item-info">
                                <span class="title">Sofort Geld - Abholung & Abmeldung inklusive</span>
                                <p>Stimmst du dem Höchstgebot zu, kümmert sich der Partnerhändler um Abholung, Bezahlung und Abmeldung.</p>
                            </div>
                        </li>
                    </ul>

                    <div
                        class="trustpilot-widget"
                        data-locale="de-DE"
                        data-template-id="5419b6a8b0d04a076446a9ad"
                        data-businessunit-id="5ffecf343b2f8b000159042a"
                        data-style-height="40px"
                        data-style-width="260px"
                        data-theme="light"
                        data-min-review-count="10"
                    >
                        <a
                        href="https://de.trustpilot.com/review/pkw.de"
                        target="_blank"
                        rel="noopener"
                        >Trustpilot</a
                        >
                    </div>
                </div>
            </div>
            </div>
        </div>
    </div>
</template>

<script>
import vSelect from 'vue-select'
import Preselector from './Preselector';
import queryString from 'query-string';

import 'vue-select/dist/vue-select.css';
import { Api } from '../services/api';
import _ from 'lodash';
import { redirectToEvaluation, redirectToEvaluationNew } from '../services/helpers';

export default {
    name: "ContentWidgetForm",
    components: {
        vSelect,
        Preselector,
    },
    data() {
        return {
            selectedTab: 0,
            showModal: {
                widget: false,
            },
        }
    },
    computed: {
      selectedOptions: function() {
        return {
          make: this.$store.state.selected.make,
          model: this.$store.state.selected.model,
          year: this.$store.state.selected.year,
        };
      },
    },
    methods: {
        selectTab(id) {
            this.selectedTab = id;
        },
        openModal(modalId) {
            this.showModal[modalId] = true;
        },
        closeModal(modalId) {
            this.showModal[modalId] = false;
        },
        makeRedirect() {        
            redirectToEvaluation(this.$store, true, 'sell_car', 'selling_lp');
        },
        makeRedirectLocal() {
            redirectToEvaluationNew(this.$store, true, 'trade_in', 'selling_lp');
        },
        handleRedirect() {
            if (this.selectedTab === 0) {
                this.makeRedirectLocal();
            } else {
                this.makeRedirect();
            }
        },
        redirectToVerkaufen () {
            redirectToEvaluation(this.$store, false);
        },
        addQueryStringAsHidden(form, newLink){
            let url = newLink;
            
            const allInputs = form.querySelectorAll('input[type="hidden"]');
            allInputs.forEach(input => input.remove());

            let index = url.indexOf("?");
            let action = url.slice(0, index)
            let params = url.slice(index);

            const queryObject = queryString.parse(params);
            Object.keys(queryObject).forEach(key => {
            const input = document.createElement('input');

            input.setAttribute('type', 'hidden');
            input.setAttribute('name', key);
            input.setAttribute('value', queryObject[key]);
                
            form.appendChild(input);
            })

            form.setAttribute("action", action);
        }
    },
    watch: {
      selectedOptions: function (newValue) {
      }
    },
    mounted: function() {
      Api.get(this.$store, this.$store.state.step);
    },
}
</script>

<style lang="scss">
    @import "~@/assets/vars";

    .station-widget-form {
        position:relative;
        padding-top:100px;

        @include breakpoint(frommediumlarge) {
            box-shadow: 0 0 24px rgba(0, 0, 0, 0.1);
            padding-top:64px
        }

        @include breakpoint(fromgiant) {
            box-shadow:none;
            position: absolute !important;
            left: 0;
            width: 100%;
            top:calc(100% - 30px);
            padding-top:0;
        }

        i {

            &.fa-map-marker {
                font-family: 'FontAwesome';
                font-weight: 400;
            }
        }

        .form-wrapper {
            position:relative;
            border-radius:0;
            padding-top:25px;
            padding-bottom:10px;
            padding-left:20px;
            padding-right:20px;
            z-index:10;
            background-color: $white;

            @include breakpoint(frommediumlarge) {
                padding-top:60px;
                padding-bottom:30px;
            }

            @include breakpoint(fromlarge) {
                padding-left:20px;
                padding-right:20px;
                border-radius:0 10px 0 0;
            }
            
            @include breakpoint(fromgiant) {
                margin-top:-143px;
                padding-top:50px;
                padding-bottom:30px;
                padding-left:50px;
                padding-right:50px;
                box-shadow: 0 0 24px rgba(0, 0, 0, 0.1);
                background:$white;
            }

            @include breakpoint(extralarge) {
                padding-left:80px;
                padding-right:80px;
            }

            @include breakpoint(full) {
            padding-left:30px;
            padding-right:30px;
            }

            @media screen and (min-width:993px) and (max-height:830px) {
                padding-top:50px;
                padding-bottom:30px;
            }

            @media screen and (min-width:993px) and (max-height:750px) {
                padding-top:30px;
                padding-bottom:30px;
            }

            .tabs {
                position:absolute;
                bottom:100%;
                left:0;
                display:flex;
                width: 100%;

                @include breakpoint(fromlarge) {
                    width:auto;
                }

                div.tab-item {
                    padding: 20px 15px;
                    border-radius: 10px 0 0 0;
                    background-color: rgba($white, .8);
                    display:flex;
                    align-items: center;
                    justify-content: center;
                    gap:8px;
                    transition: 300ms background-color ease-in-out;
                    font-size: 16px;
                    line-height: 24px;
                    font-weight: bold;
                    white-space: nowrap;
                    width:50%;
                    cursor:pointer;

                    i {
                        color: $red;
                    }

                    @include breakpoint(fromsmall) {
                        font-size: 18px;
                        line-height: 28px;
                    }
 
                    @include breakpoint(fromlarge) {
                        width:auto;
                    }

                    @include breakpoint(extralarge) {
                        font-size: 26px;
                        line-height: 32px;
                    }

                    &:nth-of-type(2) {
                        border-radius: 0 10px 0 0;
                    }

                    &.active {
                        background-color: $white;
                    }
                }
            }

            .configurator-wrapper {

                @include breakpoint(fromlarge) {
                    display:flex;
                    justify-content: space-between;
                    gap:20px;
                }

                @include breakpoint(extralarge) {
                    gap:40px;
                }

                button.go-to-wizard {
                    width:100%;
                    max-height: 74px;
                    border-radius:0;
                    white-space:nowrap;
                    font-size:17px !important;
                    line-height: 20px !important;
                    padding:12px 0 !important;
                    max-height: 60px;

                    > i {
                    padding-left: 10px;
                    }

                    @include breakpoint(fromlarge) {
                    width:25%;
                    margin-bottom:0;
                    border-radius: 40px;
                    font-size:15px !important;
                    line-height: 17px !important;
                    }

                    @include breakpoint(fromgiant) {
                        font-size:17px !important;
                        line-height: 20px !important;
                    }
                }
            }

            .note {
                display:flex;
                justify-content: center;
                margin-top:10px;
                font-size: 11px;
                line-height: 24px;

                @include breakpoint(fromlarge) {
                    justify-content: flex-end;
                    width: calc(25% - 10px);
                    display:block;
                    text-align:center;
                    margin-right:30px;
                    margin-left:auto;
                    white-space: nowrap;
                }

                @media (min-width: 1100px) {
                    margin-right:0;
                }
            }
        }
    }

    .policy-wrapper {
        background-color: #f4f4f4;
        border-radius: 0 0 10px 10px;
        padding:10px 20px;

        @include breakpoint(fromlarge) {
            padding:0;
        }
        ul {
            padding:0;
            max-width: 300px;
            margin-left:auto;
            margin-right: auto;

            @include breakpoint(fromlarge) {
                display: flex;
                max-width: none;
            }

            li {
                display: flex;
                align-items: center;
                justify-content: space-between;
                padding: 0;
                text-align: left;
                padding-left:20px;
                position:relative;
                gap: 15px;
                

                @include breakpoint(fromlarge) {
                    width: 33.33%;
                    padding: 30px 40px;
                }

                &:before {
                    content: "\f00c";
                    font-family: 'Font Awesome 5 Free';
                    font-weight: 700;
                    display: block;
                    color: $green-light;
                    font-size: 16px;
                    position: absolute;
                    left: 0;
                    top: 0;

                    @include breakpoint(fromlarge) {
                        display:none;
                    }
                }

                &:after {

                    @include breakpoint(fromlarge) {
                        content: "";
                        display: block;
                        height: 80px;
                        width: 1px;
                        background-color: #E7E7E7;
                        right: 0;
                        top: 50%;
                        transform: translateY(-50%);
                        position: absolute;
                    }
                }

                &:first-of-type {

                    @include breakpoint(fromlarge) {
                        padding-left:20px;
                    }
                }

                &:last-of-type {
                    @include breakpoint(fromlarge) {
                        padding-left:20px;
                    }
                    &:after {
                        display:none;
                    }
                }

                .icon {
                    display:none;

                    @include breakpoint(fromlarge) {
                        display: block;
                        width: 80px;
                        height: 80px;
                        background-color: #fff;
                        border-radius: 80px;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        margin: 0 auto 10px;
                    }
                }

                .policy-item-info {
                    @include breakpoint(fromlarge) {
                        width: calc(100% - 100px);
                    }

                    .title {
                        font-size: 14px;
                        line-height: 24px;
                        font-weight: bold;

                        @include breakpoint(fromlarge) {
                            line-height: 20px;
                        }

                        @include breakpoint(fromgiant) {
                            font-size: 16px;
                            line-height: 24px;
                        }

                        @include breakpoint(full) {
                            font-size: 18px;
                            line-height: 28px;
                        }
                    }

                    p {
                        display:none;

                        @include breakpoint(fromlarge) {
                            display:block;
                            font-size: 14px;
                            line-height: 20px;
                        }

                        @include breakpoint(fromgiant) {
                            font-size: 16px;
                            line-height: 24px;
                        }

                        @include breakpoint(full) {
                            font-size: 18px;
                            line-height: 26px;
                        }
                    }
                }
            }
        }

        .trustpilot-widget {
            padding:20px 0;
           display:flex;
           justify-content: center;

           @include breakpoint(fromlarge) {
            display:none;
           }
        }
    }
</style>



// WEBPACK FOOTER //
// src/station-components/ContentWidgetForm.vue